import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { Component } from '../component';
import shallowEqual from '../utils/shallowEqual';
import { CHANGE_TOPIC } from '../Datum/types';
import Checkbox from '../Checkbox/Checkbox';
import { isFunc } from '../utils/is';

var TableCheckboxAll =
/*#__PURE__*/
function (_Component) {
  _inherits(TableCheckboxAll, _Component);

  var _super = _createSuper2(TableCheckboxAll);

  function TableCheckboxAll(props) {
    var _this;

    _classCallCheck(this, TableCheckboxAll);

    _this = _super.call(this, props);
    _this.handleUpdate = void 0;
    _this.lastValueLength = void 0;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleUpdate = _this.forceUpdate.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TableCheckboxAll, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _get(_getPrototypeOf(TableCheckboxAll.prototype), "componentDidMount", this).call(this);

      this.props.datum.subscribe(CHANGE_TOPIC, this.handleUpdate);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var datum = nextProps.datum;
      if (!shallowEqual(this.props, nextProps)) return true;
      if (this.lastValueLength !== (datum.getValue() || []).length) return true;
      return false;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _get(_getPrototypeOf(TableCheckboxAll.prototype), "componentWillUnmount", this).call(this);

      this.props.datum.unsubscribe(CHANGE_TOPIC, this.handleUpdate);
    }
  }, {
    key: "getFilterData",
    value: function getFilterData() {
      var _this$props = this.props,
          _this$props$col = _this$props.col,
          col = _this$props$col === void 0 ? {} : _this$props$col,
          data = _this$props.data;
      var colTemp = col;
      var filterAll = colTemp.filterAll;

      if (data && filterAll && Array.isArray(data) && isFunc(filterAll)) {
        return filterAll(data);
      }

      return data;
    }
  }, {
    key: "getChecked",
    value: function getChecked() {
      var datum = this.props.datum;
      var filterData = this.getFilterData();
      if (datum.length === 0 || !filterData) return false;
      var checked;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = filterData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var d = _step.value;
          if (datum.disabled(d)) continue;
          var p = this.check(d);
          if (p === 'indeterminate') return p;

          if (checked === undefined) {
            checked = p;
          } else if (checked !== p) {
            return 'indeterminate';
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return checked;
    }
  }, {
    key: "check",
    value: function check(d) {
      var _this$props2 = this.props,
          datum = _this$props2.datum,
          treeColumnsName = _this$props2.treeColumnsName;
      var p = datum.check(d);
      var children = treeColumnsName && d[treeColumnsName];
      var isArray = children && Array.isArray(children);

      if (isArray) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = children[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var c = _step2.value;
            if (this.check(c) !== p) return 'indeterminate';
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
              _iterator2["return"]();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }

      return p;
    }
  }, {
    key: "handleChange",
    value: function handleChange(_, checked, index) {
      var _this$props3 = this.props,
          datum = _this$props3.datum,
          treeColumnsName = _this$props3.treeColumnsName;
      var filterData = this.getFilterData();

      if (checked) {
        datum.add(filterData, index, treeColumnsName);
      } else {
        datum.remove(filterData, index, treeColumnsName);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var datum = this.props.datum;
      this.lastValueLength = (datum.getValue() || []).length;
      if (datum.limit === 1) return null;
      return (
        /*#__PURE__*/
        React.createElement(Checkbox, Object.assign({}, this.props, {
          checked: this.getChecked(),
          onChange: this.handleChange
        }))
      );
    }
  }]);

  return TableCheckboxAll;
}(Component);

export { TableCheckboxAll as default };